// actions.js

import axios from 'axios';
import Cookies from 'js-cookie';

export default {
    
    async getProfile({ commit, state, rootState, rootGetters }, { id }) {

        const access_token = rootGetters.access_token;
        const config = {
            headers: {
                'Authorization': `${access_token}`
            }
        };
        
        try {
            const response = await axios.get(`${process.env.VUE_APP_APIGATEWAY}/api/v1/profiles/${id}`, config);
            return response.data;
        } catch (error) {
            return error;
        }
    },

    async getProfileByToken({ commit, state, rootState, rootGetters }) {

        const access_token = rootGetters.access_token;
        const config = {
            headers: {
                'Authorization': `${access_token}`
            }
        };

        try {
            const response = await axios.get(`${process.env.VUE_APP_APIGATEWAY}/api/v1/profile/`, config);
            return response.data;
        } catch (error) {
            return error;
        }
    },


    async getProfiles({ commit, state, rootState, rootGetters }, { id }) {
        try {
            // Получаем токен из состояния хранилища
            const access_token = rootGetters.access_token;


            // Создаем объект конфигурации для запроса с заголовком авторизации
            const config = {
                headers: {
                    'Authorization': `${access_token}`
                }
            };

            // Выполняем GET запрос с использованием Axios и передаем конфигурацию
            const response = await axios.get(`${process.env.VUE_APP_APIGATEWAY}/api/v1/profiles`, config);

            // Возвращаем данные ответа
            return {
                status: response.status,
                data: response.data
            }
        } catch (error) {
            if (error.response) {
                // Сервер вернул ответ с ошибкой (код статуса не в диапазоне 2xx)
                return {
                    status: error.response.status,
                    message: error.response.data.message || 'Registration failed'
                };
            } else if (error.request) {
                // Запрос был сделан, но ответа не получено
                return {
                    status: 0,
                    message: 'No response received from server'
                };
            } else {
                // Что-то пошло не так при настройке запроса
                return {
                    status: -1,
                    message: error.message
                };
            }
        }
    },

    async createProfile  ({ commit, state, rootState, rootGetters  }, {  user_id, company_id, first_name,last_name, email, phone_number, address }) {
        const access_token = rootGetters.access_token;

        try {
            const response = await axios.post(
                `${process.env.VUE_APP_APIGATEWAY}/api/v1/profiles/${user_id}`,
                {
                    user_id:user_id,
                    company_id:company_id,
                    first_name:first_name,
                    last_name:last_name,
                    email: email,
                    phone_number: phone_number,
                    address: address,
                },
                {
                    headers: {
                        'Authorization': `${access_token}`
                    }
                }
            );

            return {
                status: response.status,
                data: response.data
            };
        } catch (error) {
            if (error.response) {
                // Сервер вернул ответ с ошибкой (код статуса не в диапазоне 2xx)
                return {
                    status: error.response.status,
                    message: error.response.data.message || 'Registration failed'
                };
            } else if (error.request) {
                // Запрос был сделан, но ответа не получено
                return {
                    status: 0,
                    message: 'No response received from server'
                };
            } else {
                // Что-то пошло не так при настройке запроса
                return {
                    status: -1,
                    message: error.message
                };
            }
        }
    },

    async updateProfile  ({ commit, state, rootState, rootGetters  }, {  user_id, company_id, first_name,last_name, email, phone_number, address }) {
       const access_token = rootGetters.access_token;

        try {
            const response = await axios.put(
                `${process.env.VUE_APP_APIGATEWAY}/api/v1/profiles/${user_id}`,
                {
                    user_id:user_id,
                    company_id:company_id,
                    first_name:first_name,
                    last_name:last_name,
                    email: email,
                    phone_number: phone_number,
                    address: address,
                },
                {
                    headers: {
                        'Authorization': `${access_token}`
                    }
                }
            );

            return {
                status: response.status,
                data: response.data
            };
        } catch (error) {
            if (error.response) {
                // Сервер вернул ответ с ошибкой (код статуса не в диапазоне 2xx)
                return {
                    status: error.response.status,
                    message: error.response.data.message || 'Registration failed'
                };
            } else if (error.request) {
                // Запрос был сделан, но ответа не получено
                return {
                    status: 0,
                    message: 'No response received from server'
                };
            } else {
                // Что-то пошло не так при настройке запроса
                return {
                    status: -1,
                    message: error.message
                };
            }
        }
    },


    async updateProfileByToken  ({ commit, state, rootState, rootGetters  }, {  company_id, first_name,last_name, email, phone_number, address }) {
        const access_token = rootGetters.access_token;

        try {
            const response = await axios.put(
                `${process.env.VUE_APP_APIGATEWAY}/api/v1/profile`,
                {
                    company_id:company_id,
                    first_name:first_name,
                    last_name:last_name,
                    email: email,
                    phone_number: phone_number,
                    address: address,
                },
                {
                    headers: {
                        'Authorization': `${access_token}`
                    }
                }
            );

            return {
                status: response.status,
                data: response.data
            };
        } catch (error) {
            if (error.response) {
                // Сервер вернул ответ с ошибкой (код статуса не в диапазоне 2xx)
                return {
                    status: error.response.status,
                    message: error.response.data.message || 'Registration failed'
                };
            } else if (error.request) {
                // Запрос был сделан, но ответа не получено
                return {
                    status: 0,
                    message: 'No response received from server'
                };
            } else {
                // Что-то пошло не так при настройке запроса
                return {
                    status: -1,
                    message: error.message
                };
            }
        }
    },


 


};
